module.exports = __webpack_public_path__ + "img/model_tx.e4b9ae76.png";